import request from '@/utils/request'


// 查询商家账户流水列表
export function listMerchantAccountBill(query) {
  return request({
    url: '/biz/admin/merchant/account/bill/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家账户流水分页
export function pageMerchantAccountBill(query) {
  return request({
    url: '/biz/admin/merchant/account/bill/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}


// 查询商家账户流水分页
export function pageMerchantAccountBillOrder(query) {
  return request({
    url: '/biz/admin/merchant/account/bill/order/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家账户流水详细
export function getMerchantAccountBill(data) {
  return request({
    url: '/biz/admin/merchant/account/bill/detail',
    method: 'get',
    params: data
  })
}

export function getMerchantAccountBalance(data) {
  return request({
    url: '/biz/admin/merchant/merchant/account/balance',
    method: 'get',
    params: data
  })
}

export function getMerchantAccount(data) {
  return request({
    url: '/biz/admin/merchant/merchant/balance',
    method: 'post',
    data: data
  })
}


// 新增商家账户流水
export function addMerchantAccountBill(data) {
  return request({
    url: '/biz/admin/merchant/account/bill/add',
    method: 'post',
    data: data
  })
}

// 修改商家账户流水
export function updateMerchantAccountBill(data) {
  return request({
    url: '/biz/admin/merchant/account/bill/edit',
    method: 'post',
    data: data
  })
}

// 删除商家账户流水
export function delMerchantAccountBill(data) {
  return request({
    url: '/biz/admin/merchant/account/bill/delete',
    method: 'post',
    data: data
  })
}


export function merchantSettle(data) {
  return request({
    url: '/biz/admin/merchant/account/bill/settle',
    method: 'post',
    data: data
  })
}


